
export enum OperationTypes {
    LOGIN_WITH_EGN = 'loginWithEgn',
    LOGIN_WITH_QR = 'loginWithQr',
    TO_BE_CONFIRMED = 'toBeConfirmed',
    EGN_SAME_AS_LNC = 'egnSameAsLnc',
    WAIT = 'wait',
    EMERGENCY_LOGIN = 'emergencyLogin',
    CONFIRM_CODE = 'confirmCode',
    EMERGENCY_LOGIN_SUCCESS = 'validateEmergencyCode'
}
